module.exports = __webpack_public_path__ + "static/img/info_title3.0e7b5a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/info_title3.png
// module id = eh0N
// module chunks = 4